import { Link } from "react-router-dom";

export const Footer = () => {
  const integrations = [
    { name: "Fix Datadog Bugs", url: "/integrations/datadog" },
    { name: "Fix New Relic Bugs", url: "/integrations/newrelic" },
    { name: "Fix Sentry Bugs", url: "/integrations/sentry" },
    { name: "Fix Zipy Bugs", url: "/integrations/zipy" },
    { name: "Fix Bugs in Lovable Apps", url: "/platforms/lovable" },
    { name: "Fix Bugs in Bolt Apps", url: "/platforms/bolt" },
  ];

  const platforms = [
    { name: "GitHub", url: "/platforms/github" },
    { name: "GitLab", url: "/platforms/gitlab" },
    { name: "Bitbucket", url: "/platforms/bitbucket" },
  ];

  return (
    <footer className="py-16 px-4 border-t border-border bg-background">
      <div className="container mx-auto max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {/* Integrations */}
          <div>
            <h3 className="font-heading text-sm font-semibold mb-4 text-foreground">
              Integrations
            </h3>
            <ul className="space-y-3">
              {integrations.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.url}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Supported Platforms */}
          <div>
            <h3 className="font-heading text-sm font-semibold mb-4 text-foreground">
              Supported Platforms
            </h3>
            <ul className="space-y-3">
              {platforms.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.url}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-center md:text-left">
            <p className="text-sm text-muted-foreground">
              © 2026 Healion.ai. All rights reserved.
            </p>
          </div>
          <div className="flex items-center gap-6">
            <Link
              to="/changelog"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Changelog
            </Link>
            <Link
              to="/privacy-policy"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-of-service"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
